import { ExpenseReimbursement, ExpenseStatus } from '@/types/expense';
import { postEdgeFunctionAction } from './postEdgeFunctionAction';

export class ExpenseApiClient {
  private async callApi(action: string, data: Record<string, unknown> = {}): Promise<any> {
    return postEdgeFunctionAction('expense-api', action, data);
  }

  async createExpense(receiptFilePath: string, receiptFileName: string, employeeId?: string): Promise<ExpenseReimbursement> {
    return this.callApi('createExpense', { receiptFilePath, receiptFileName, employeeId });
  }

  async completeExtraction(expenseId: string, extractedData: Record<string, unknown>): Promise<ExpenseReimbursement> {
    return this.callApi('completeExtraction', { expenseId, extractedData });
  }

  async markExtractionFailed(expenseId: string): Promise<ExpenseReimbursement> {
    return this.callApi('markExtractionFailed', { expenseId });
  }

  async saveManualData(
    expenseId: string,
    documentData: Record<string, unknown>,
    expenseData: Record<string, unknown>
  ): Promise<ExpenseReimbursement> {
    return this.callApi('saveManualData', { expenseId, documentData, expenseData });
  }

  async approveSuggestion(expenseId: string): Promise<ExpenseReimbursement> {
    return this.callApi('approveSuggestion', { expenseId });
  }

  async approveAndQueuePayment(expenseId: string): Promise<{ expense: ExpenseReimbursement; payable: any }> {
    return this.callApi('approveAndQueuePayment', { expenseId });
  }

  async bulkApproveAndQueuePayment(expenseIds: string[]): Promise<{
    successes: { expense: ExpenseReimbursement; payable: any }[];
    failures: { expenseId: string; error: string }[];
  }> {
    return this.callApi('bulkApproveAndQueuePayment', { expenseIds });
  }

  async approveAndMarkPaidExternally(expenseId: string, paidDate: string, actualSekAmount?: number): Promise<ExpenseReimbursement> {
    return this.callApi('approveAndMarkPaidExternally', { expenseId, paidDate, actualSekAmount });
  }

  async bulkApproveAndMarkPaidExternally(expenseIds: string[], paidDate: string): Promise<{
    successes: ExpenseReimbursement[];
    failures: { expenseId: string; error: string }[];
  }> {
    return this.callApi('bulkApproveAndMarkPaidExternally', { expenseIds, paidDate });
  }

  async updateEmployee(expenseId: string, employeeId: string | null): Promise<ExpenseReimbursement> {
    return this.callApi('updateEmployee', { expenseId, employeeId });
  }

  async rejectExpense(expenseId: string, reason: string): Promise<ExpenseReimbursement> {
    return this.callApi('rejectExpense', { expenseId, reason });
  }

  async listExpenses(filters?: { status?: ExpenseStatus; employeeId?: string }): Promise<ExpenseReimbursement[]> {
    return this.callApi('listExpenses', { filters });
  }

  async getExpense(expenseId: string): Promise<ExpenseReimbursement> {
    return this.callApi('getExpense', { expenseId });
  }
}
